import React, { Fragment } from 'react';
import { Modal, Button } from 'grab-ui';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import css from './cancel-multiple-confirm-modal.less';

const CancelMultipleConfirmModal = ({
  handleClose,
  visible,
  handleCancelOrderModal,
  orderAmt,
}) => (
  <div className={css.modalContainer}>
    <Modal
      className={css.modalContainer}
      centered
      visible={visible}
      onOk={handleClose}
      footer={[
        <div className={css.footerContainer} key="buttons">
          <div key="cancel" className={classnames(css.btnContainer)}>
            <Button
              className={classnames(css.smallButton, css.modalButton)}
              key="keep"
              onClick={handleClose}
            >
              <span>{I18n.t('history.cancelMultipleModal.no')}</span>
            </Button>
          </div>
          <div key="ok" className={classnames(css.btnContainer)}>
            <Button
              type="primary"
              className={classnames(
                css.cancelButton,
                css.keepButton,
                css.modalButton,
              )}
              key="keep"
              onClick={() => handleCancelOrderModal()}
            >
              <span>{I18n.t('history.cancelMultipleModal.yes')}</span>
            </Button>
          </div>
        </div>,
      ]}
      maskStyle={{ backgroundColor: 'rgba(28, 28, 28, 0.5)' }}
    >
      <Fragment>
        <h3>
          {I18n.t('history.cancelMultipleModal.title', { amt: orderAmt })}
        </h3>
        <div>
          <span>{I18n.t('history.cancelMultipleModal.text')}</span>
        </div>
      </Fragment>
    </Modal>
  </div>
);

CancelMultipleConfirmModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleCancelOrderModal: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  orderAmt: PropTypes.number,
};
CancelMultipleConfirmModal.defaultProps = {
  orderAmt: 0,
};

export default CancelMultipleConfirmModal;
